__turbopack_context__.v({
  "helios-action-section": "qwZ-Bq_helios-action-section",
  "helios-action-section--align-center": "qwZ-Bq_helios-action-section--align-center",
  "helios-action-section--band-brand": "qwZ-Bq_helios-action-section--band-brand",
  "helios-action-section--band-dark": "qwZ-Bq_helios-action-section--band-dark",
  "helios-action-section--band-subtle": "qwZ-Bq_helios-action-section--band-subtle",
  "helios-action-section--has-body": "qwZ-Bq_helios-action-section--has-body",
  "helios-action-section--layout-split": "qwZ-Bq_helios-action-section--layout-split",
  "helios-action-section--surface-brand": "qwZ-Bq_helios-action-section--surface-brand",
  "helios-action-section--surface-page": "qwZ-Bq_helios-action-section--surface-page",
  "helios-action-section--surface-panel": "qwZ-Bq_helios-action-section--surface-panel",
  "helios-action-section--surface-subtle": "qwZ-Bq_helios-action-section--surface-subtle",
  "helios-action-section--surface-transparent": "qwZ-Bq_helios-action-section--surface-transparent",
  "helios-action-section--title-compact": "qwZ-Bq_helios-action-section--title-compact",
  "helios-action-section--title-default": "qwZ-Bq_helios-action-section--title-default",
  "helios-action-section--title-display": "qwZ-Bq_helios-action-section--title-display",
  "helios-action-section--tone-inverse": "qwZ-Bq_helios-action-section--tone-inverse",
  "helios-action-section--variant-conversion": "qwZ-Bq_helios-action-section--variant-conversion",
  "helios-action-section__actions": "qwZ-Bq_helios-action-section__actions",
  "helios-action-section__body": "qwZ-Bq_helios-action-section__body",
  "helios-action-section__container": "qwZ-Bq_helios-action-section__container",
  "helios-action-section__container--md": "qwZ-Bq_helios-action-section__container--md",
  "helios-action-section__content": "qwZ-Bq_helios-action-section__content",
  "helios-action-section__eyebrow": "qwZ-Bq_helios-action-section__eyebrow",
  "helios-action-section__facts": "qwZ-Bq_helios-action-section__facts",
  "helios-action-section__title": "qwZ-Bq_helios-action-section__title",
  "helios-action-section__title--compact": "qwZ-Bq_helios-action-section__title--compact",
  "helios-action-section__title--default": "qwZ-Bq_helios-action-section__title--default",
  "helios-action-section__title--display": "qwZ-Bq_helios-action-section__title--display",
  "helios-action-section__wrap": "qwZ-Bq_helios-action-section__wrap",
});
